<template>
    <div
        class="centre-absolute aspect-square w-6 before:block before:h-full before:w-full before:animate-spin before:rounded-full before:border-4 before:border-solid before:border-brand1 before:border-b-white before:border-l-white before:border-r-transparent before:border-t-transparent"
    ></div>
</template>
